module.exports = __webpack_public_path__ + "img/latitude.9be41e9d.svg";